import { z } from 'zod';
import { AuditActionSchema } from './enums.js';

export const AuditLogEntrySchema = z.object({
  id: z.string(),
  userId: z.string().uuid().nullable(),
  userName: z.string().nullable(),
  action: AuditActionSchema,
  entityType: z.string(),
  entityId: z.string().nullable(),
  beforeJson: z.record(z.any()).nullable(),
  afterJson: z.record(z.any()).nullable(),
  ipAddress: z.string().nullable(),
  userAgent: z.string().nullable(),
  createdAt: z.string(),
});
export type AuditLogEntry = z.infer<typeof AuditLogEntrySchema>;

export const AuditQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(200).default(50),
  userId: z.string().uuid().optional(),
  entityType: z.string().optional(),
  entityId: z.string().optional(),
  action: AuditActionSchema.optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
});
export type AuditQuery = z.infer<typeof AuditQuerySchema>;
